<template>
  <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
  <div style="width: 90%; margin-top: 3%;">
    <div style="text-align: center">
      <!-- <h1>营收状况分析</h1> -->
      <div id="mainExpenditure"
           v-if="true"></div>
    </div>

  </div>
</ShowControl>
</template>

<script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  components: {ShowControl},
  data () {
    return {
      title: '营收状况分析',
      option: {
        title: {
          text: '收支分析'
        },
        tooltip: {
   
          },
        legend: {
          data: ['收入', '支出',]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '收入',
            type: 'bar',
            data: []
          },
          {
            name: '支出',
            type: 'bar',
            data: []
          },
        ]
      }
    }
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      ChatShow:(state) => state.user.chatShows,
    }),
  },
  mounted () {
    this.GetRevenueAndExpenditure()
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      this.$router.push("/FinancialManagement")
    },
    GetRevenueAndExpenditure () {
      this.$http.get(`Income/GetRevenueAndExpenditure?round=${this.Round}`).then((res) => {
        if (res.success) {
          this.option.series[0].data = res.dynamicObj.incomeList;
          this.option.series[1].data = res.dynamicObj.payList
          this.info();
          this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.查看营收状况分析 });  
        }
      })
    },
    info () {
      this.$nextTick(_ => {
        console.log(_)
        var myChart = this.echarts.init(document.getElementById('mainExpenditure'));
        myChart.clear();
        myChart.setOption(this.option);
        window.onresize = function () {
          myChart.resize();
        };
      })
    },
  },
}
</script>

<style   scoped>
#mainExpenditure {
  width: 100%;
  height: calc(100vw * 500 / 1920);
}
</style>